import React from "react";
import Image from "next/image";

const Preloader = () => {
  return (
    <>
      <div className="preloader">
        <div className="content">
          <div className="logo-container">
            <Image src="/images/coursepage.svg" alt="Logo" width={200} height={200} />
          </div>

          <div className="handwriting-container">
            <svg className="handwriting-svg" viewBox="-150 350 300 100">
              <path
                className="handwriting-path"
                d="M-84.66 387.59Q-83.34 387.59-81.95 388.78Q-80.56 389.97-80.56 392.42Q-80.56 394.87-82.28 398.78Q-84.00 402.69-87.00 406.72Q-90.00 410.76-93.60 414.32Q-97.20 417.87-101.37 420.14Q-105.54 422.42-108.94 422.42Q-112.34 422.42-114.39 420.28Q-116.45 418.14-116.45 414.32Q-116.45 410.50-114.57 405.86Q-112.69 401.23-109.74 397.68Q-106.78 394.12-103.34 391.30L-103.34 391.30Q-96.14 385.51-90.71 385.51L-90.71 385.51Q-88.28 385.51-87.05 386.71L-87.05 386.71Q-86.61 387.10-86.61 387.41L-86.61 387.41L-86.61 387.68Q-85.99 387.59-84.66 387.59ZM-89.12 393.46L-89.12 393.46L-89.43 393.46Q-90.98 393.46-90.98 391.21L-90.98 391.21Q-94.20 392.27-97.73 394.92Q-101.26 397.57-104.04 401.19L-104.04 401.19Q-109.69 408.42-109.78 413.41L-109.78 413.41Q-109.78 415.88-107.97 415.88Q-106.16 415.88-102.59 413.50Q-99.01 411.12-95.50 406.70Q-91.99 402.29-90.25 399.04Q-88.50 395.80-88.50 394.63Q-88.50 393.46-89.12 393.46Z"
                stroke="none"
                fill="#f69220"
              />
              <path
                className="handwriting-path"
                d="M-65.35 394.39L-67.20 397.17Q-56.78 385.34-49.46 385.34L-49.46 385.34Q-47.65 385.34-46.48 386.42Q-45.31 387.50-45.31 389.22Q-45.31 390.94-47.76 394.98Q-50.21 399.02-52.28 401.80L-52.28 401.80Q-53.39 403.22-54.78 403.22Q-56.17 403.22-56.94 402.20Q-57.71 401.19-57.71 399.82L-57.71 399.82Q-57.71 396.77-54.44 392.93L-54.44 392.93L-54.53 392.84Q-55.99 392.97-61.75 398.58Q-67.51 404.19-71.55 408.62Q-75.59 413.06-80.31 419.42L-80.31 419.42Q-81.68 421.31-82.63 421.31Q-83.58 421.31-85.15 420.72Q-86.71 420.12-87.04 419.86Q-87.37 419.59-87.37 418.97Q-87.37 418.36-87.02 417.54Q-86.67 416.72-85.72 415.22Q-84.77 413.72-82.85 410.37Q-80.93 407.01-76.87 400.21Q-72.81 393.42-72.01 392.00L-72.01 392.00Q-70.34 389.09-69.28 387.77L-69.28 387.77Q-67.29 385.25-62.57 385.25L-62.57 385.25Q-61.51 385.25-61.51 386.57L-61.51 386.57Q-61.51 388.65-65.35 394.39L-65.35 394.39Z"
                stroke="none"
                fill="#f69220"
              />
              <path
                className="handwriting-path"
                d="M-20.90 372.76L-20.90 372.76Q-20.90 375.27-23.24 377.81Q-25.58 380.35-28.12 380.35Q-30.65 380.35-30.65 377.70Q-30.65 375.05-28.43 372.65Q-26.20 370.24-23.50 370.24L-23.50 370.24Q-22.31 370.24-21.61 370.90Q-20.90 371.57-20.90 372.76ZM-28.05 411.29L-28.05 411.29Q-28.05 412.62-28.32 413.19L-28.32 413.19Q-30.48 417.61-35.20 420.32Q-39.92 423.04-43.41 423.04Q-46.90 423.04-49.42 420.70Q-51.93 418.36-51.93 415.93Q-51.93 413.50-49.50 408.87Q-47.08 404.23-44.65 400.30Q-42.22 396.37-42.22 396.04Q-42.22 395.71-43.12 394.74Q-44.03 393.77-44.03 393.31Q-44.03 392.84-42.20 390.88Q-40.37 388.91-37.74 386.99Q-35.11 385.07-33.72 385.07Q-32.33 385.07-31.23 386.31Q-30.13 387.55-30.13 388.56Q-30.13 389.58-40.63 407.67L-40.63 407.67Q-40.76 407.94-41.36 408.84Q-41.96 409.75-42.29 410.34Q-42.62 410.94-43.06 411.78L-43.06 411.78Q-43.94 413.54-43.94 414.74L-43.94 414.74Q-43.94 416.24-41.91 416.24Q-39.88 416.24-37.70 414.85Q-35.51 413.46-33.92 411.78L-33.92 411.78Q-29.77 407.32-29.20 407.32L-29.20 407.32Q-28.05 407.32-28.05 411.29Z"
                stroke="none"
                fill="#f69220"
              />
              <path
                className="handwriting-path"
                d="M-17.89 391.89Q-13.63 388.96-9.52 387.37Q-5.42 385.78-2.41 385.78Q0.59 385.78 1.43 387.50L1.43 387.50Q3.15 385.51 5.71 385.38L5.71 385.38Q6.46 385.34 7.56 385.34Q8.67 385.34 8.93 385.63Q9.20 385.91 9.42 386.71Q9.64 387.50 9.68 387.59Q9.72 387.68 9.72 387.88Q9.72 388.08 9.50 388.36Q9.28 388.65 9.00 388.91Q8.71 389.18 8.67 389.22L8.67 389.22Q-1.09 403.22-11.29 421.14L-11.29 421.14Q-0.78 411.82 7.52 407.76L7.52 407.76Q8.05 407.50 8.53 407.50L8.53 407.50Q9.24 407.50 9.46 408.40Q9.68 409.31 9.68 410.98Q9.68 412.66 9.48 413.06Q9.28 413.46 7.43 414.65Q5.58 415.84 2.62 417.74Q-0.34 419.64-3.65 421.93L-3.65 421.93Q-11.60 427.45-16.72 433.54L-16.72 433.54Q-23.34 441.53-26.21 446.43L-26.21 446.43Q-27.27 448.33-29.78 448.33L-29.78 448.33Q-34.77 448.33-34.77 443.61L-34.77 443.61Q-34.77 438.79-30.05 433.76L-30.05 433.76Q-26.52 430.01-23.56 427.63Q-20.60 425.24-20.34 424.93L-20.34 424.93Q-17.07 420.03-11.46 411.03L-11.46 411.03Q-16.23 416.02-20.71 418.97Q-25.19 421.93-27.40 421.93L-27.40 421.93Q-34.15 421.93-34.15 416.15L-34.15 416.15Q-34.15 411.56-31.81 406.88Q-29.47 402.20-25.81 398.51Q-22.15 394.83-17.89 391.89ZM-1.09 390.77L-1.09 390.77Q-6.21 391.87-10.71 394.41Q-15.22 396.95-18.13 399.84Q-21.04 402.73-23.16 405.78L-23.16 405.78Q-27.13 411.47-27.13 414.60L-27.13 414.60Q-27.13 415.35-26.76 415.35Q-26.38 415.35-25.08 414.56Q-23.78 413.77-21.39 411.85Q-19.01 409.93-16.10 407.28L-16.10 407.28Q-9.34 401.05-1.09 390.77Z"
                stroke="none"
                fill="#f69220"
              />
              <path
                className="handwriting-path"
                d="M35.10 372.76L35.10 372.76Q35.10 375.27 32.76 377.81Q30.42 380.35 27.88 380.35Q25.35 380.35 25.35 377.70Q25.35 375.05 27.57 372.65Q29.80 370.24 32.50 370.24L32.50 370.24Q33.69 370.24 34.39 370.90Q35.10 371.57 35.10 372.76ZM27.95 411.29L27.95 411.29Q27.95 412.62 27.68 413.19L27.68 413.19Q25.52 417.61 20.80 420.32Q16.08 423.04 12.59 423.04Q9.10 423.04 6.58 420.70Q4.07 418.36 4.07 415.93Q4.07 413.50 6.50 408.87Q8.92 404.23 11.35 400.30Q13.78 396.37 13.78 396.04Q13.78 395.71 12.88 394.74Q11.97 393.77 11.97 393.31Q11.97 392.84 13.80 390.88Q15.63 388.91 18.26 386.99Q20.89 385.07 22.28 385.07Q23.67 385.07 24.77 386.31Q25.87 387.55 25.87 388.56Q25.87 389.58 15.37 407.67L15.37 407.67Q15.24 407.94 14.64 408.84Q14.04 409.75 13.71 410.34Q13.38 410.94 12.94 411.78L12.94 411.78Q12.06 413.54 12.06 414.74L12.06 414.74Q12.06 416.24 14.09 416.24Q16.12 416.24 18.30 414.85Q20.49 413.46 22.08 411.78L22.08 411.78Q26.23 407.32 26.80 407.32L26.80 407.32Q27.95 407.32 27.95 411.29Z"
                stroke="none"
                fill="#f69220"
              />
              <path
                className="handwriting-path"
                d="M47.41 414.43L47.41 414.43Q47.41 416.37 50.05 416.37L50.05 416.37Q51.47 416.37 53.61 414.96Q55.75 413.54 57.47 411.87L57.47 411.87Q62.06 407.32 62.68 407.32L62.68 407.32Q63.83 407.32 63.83 410.63Q63.83 413.94 61.75 415.18L61.75 415.18Q55.44 420.87 52.00 422.11L52.00 422.11Q50.05 422.77 47.72 422.73Q45.38 422.68 43.08 420.70Q40.78 418.71 40.78 415.86Q40.78 413.02 42.29 409.40Q43.79 405.78 45.35 403.19Q46.92 400.61 49.22 397.19Q51.51 393.77 51.64 392.93L51.64 392.93L51.56 392.84Q50.10 392.97 44.34 398.58Q38.58 404.19 34.83 408.34Q31.07 412.49 25.87 419.42L25.87 419.42Q24.41 421.31 23.48 421.31Q22.55 421.31 20.99 420.72Q19.42 420.12 19.07 419.86Q18.71 419.59 18.71 419.06Q18.71 418.53 19.02 417.76Q19.33 416.99 19.62 416.48Q19.91 415.97 20.57 414.91Q21.23 413.85 23.19 410.43Q25.16 407.01 29.22 400.21Q33.28 393.42 34.08 392.00L34.08 392.00Q35.75 389.09 36.81 387.77L36.81 387.77Q38.80 385.25 43.52 385.25L43.52 385.25Q44.58 385.25 44.58 386.57L44.58 386.57Q44.58 388.65 40.74 394.39L40.74 394.39L38.89 397.17Q46.52 388.69 51.78 386.44L51.78 386.44Q54.34 385.34 56.39 385.34Q58.44 385.34 59.66 386.44Q60.87 387.55 60.87 388.89Q60.87 390.24 59.94 392.11Q59.02 393.99 58.07 395.47Q57.12 396.95 55.57 399.20Q54.03 401.45 53.89 401.65Q53.76 401.85 53.21 402.71Q52.66 403.57 52.39 403.97Q52.13 404.36 51.51 405.36Q50.89 406.35 50.52 407.01Q50.14 407.67 49.59 408.65Q49.04 409.62 48.71 410.32Q48.38 411.03 48.02 411.87L48.02 411.87Q47.41 413.41 47.41 414.43Z"
                stroke="none"
                fill="#f69220"
              />
              <path
                className="handwriting-path"
                d="M93.04 387.68L93.04 387.68Q96.40 387.68 96.40 389.97L96.40 389.97Q96.40 391.21 95.83 391.78Q95.25 392.36 93.38 395.60Q91.50 398.85 89.23 403.90Q86.95 408.95 86.29 412.53L86.29 412.53Q86.16 412.97 86.16 413.77L86.16 413.77Q86.16 416.19 87.48 416.19Q88.81 416.19 90.62 414.94Q92.43 413.68 93.84 412.24Q95.25 410.81 96.60 409.31Q97.94 407.81 98.21 407.59Q98.47 407.36 99.00 407.36L99.00 407.36Q99.84 407.36 100.02 408.65Q100.20 409.93 100.20 411.29Q100.20 412.66 99.93 413.19L99.93 413.19Q98.65 415.71 94.30 419.24Q89.95 422.77 86.40 422.77Q82.85 422.77 81.17 420.61Q79.49 418.44 79.49 415.82Q79.49 413.19 80.38 411.21L80.38 411.21Q76.71 415.97 71.97 419.28Q67.22 422.59 64.22 422.59Q61.22 422.59 59.32 420.78L59.32 420.78Q56.89 418.53 56.89 414.54Q56.89 410.54 58.68 406.50Q60.47 402.47 63.38 399.13Q66.29 395.80 69.78 393.06L69.78 393.06Q77.11 387.32 83.29 387.32L83.29 387.32Q85.67 387.32 87.17 388.12Q88.67 388.91 89.07 390.11L89.07 390.11Q90.13 388.52 90.86 388.10Q91.59 387.68 93.04 387.68ZM87.17 392.58L87.17 392.58Q79.63 392.58 71.55 400.96L71.55 400.96Q68.68 403.97 66.27 408.16Q63.87 412.35 63.87 413.90Q63.87 415.44 64.75 415.44L64.75 415.44Q65.99 415.44 71.64 410.57Q77.29 405.69 79.14 403.39L79.14 403.39Q81.17 400.83 87.17 392.58Z"
                stroke="none"
                fill="#f69220"
              />
              <path
                className="handwriting-path"
                d="M132.96 354.97Q135.08 354.97 136.69 356.23Q138.30 357.48 138.30 359.96Q138.30 362.43 135.56 367.70Q132.83 372.98 128.98 378.47Q125.14 383.97 120.29 390.15L120.29 390.15Q112.61 399.95 105.55 407.76L105.55 407.76Q105.50 408.29 105.17 409.73Q104.84 411.16 104.84 412.62Q104.84 414.07 106.19 415.24Q107.53 416.41 109.52 416.41Q111.50 416.41 113.78 415.00Q116.05 413.59 117.73 411.87L117.73 411.87Q122.14 407.32 123.20 407.32Q124.26 407.32 124.26 410.54L124.26 410.54L124.26 411.43Q124.26 413.15 123.64 413.94L123.64 413.94Q119.94 418.49 115.30 420.72Q110.67 422.95 106.52 422.95Q102.37 422.95 100.20 420.41Q98.04 417.87 98.04 413.46L98.04 413.46Q98.04 404.85 102.65 393.22Q107.27 381.59 113.05 373.42L113.05 373.42Q126.07 354.97 132.96 354.97L132.96 354.97ZM130.97 362.30L130.97 362.30Q130.97 361.63 130.53 361.63L130.53 361.63Q128.98 361.63 122.41 370.46Q115.83 379.29 112.90 384.54Q109.96 389.80 107.36 397.74L107.36 397.74Q112.56 391.56 121.77 378.47Q130.97 365.39 130.97 362.30Z"
                stroke="none"
                fill="#f69220"
              />
              <path
                className="handwriting-path"
                d="M124.22 412.40L124.22 412.40L124.18 413.10Q124.18 414.21 125.01 415.00Q125.85 415.80 126.56 415.80L126.56 415.80Q131.86 415.80 135.94 414.21Q140.02 412.62 140.02 411.03L140.02 411.03Q140.02 410.28 138.54 409.73Q137.07 409.17 133.56 408.36Q130.05 407.54 128.46 407.08Q126.87 406.61 125.94 406.22Q125.01 405.82 124.04 405.11L124.04 405.11Q121.97 403.66 121.97 400.77Q121.97 397.87 124.11 395.03Q126.25 392.18 129.47 390.15Q132.69 388.12 136.40 386.57L136.40 386.57Q143.73 383.53 148.72 383.53L148.72 383.53Q153.62 383.53 154.77 385.65L154.77 385.65Q155.12 386.40 155.12 387.32L155.12 387.32L155.12 387.63Q155.12 389.97 154.13 391.30Q153.13 392.62 150.99 393.68Q148.85 394.74 147.59 394.74Q146.33 394.74 146.00 394.56Q145.67 394.39 145.45 394.10Q145.23 393.81 144.90 393.68Q144.57 393.55 144.57 393.02Q144.57 392.49 145.01 391.94Q145.45 391.39 145.63 390.77L145.63 390.77Q142.72 390.90 139.54 392.11Q136.36 393.33 134.09 394.83Q131.81 396.33 130.31 397.70Q128.81 399.07 128.81 399.71Q128.81 400.35 130.84 400.74L130.84 400.74Q139.98 402.55 142.85 403.88Q145.72 405.20 146.82 406.88Q147.92 408.56 147.92 409.93L147.92 409.93Q147.92 412.75 145.67 415.27Q143.42 417.78 140.11 419.37L140.11 419.37Q133.00 422.86 127.73 422.86Q122.45 422.86 120.45 421.25Q118.44 419.64 118.44 417.43Q118.44 415.22 119.56 413.35Q120.69 411.47 122.45 411.47Q124.22 411.47 124.22 412.40Z"
                stroke="none"
                fill="#f69220"
              />
            </svg>
          </div>
        </div>
      </div>

      <style jsx>{`
        .preloader {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #ffffff;
          z-index: 9999;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .content {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .logo-container {
          animation: logoAnimation 1s linear 1 forwards;
        }

        .handwriting-container {
          opacity: 0;
          position: relative;
          left: 70px;
          bottom: 20px;
          animation: reveal 0s forwards 1s;
        }

        @keyframes reveal {
          to {
            opacity: 1;
          }
        }

        .handwriting-svg {
          width: 125px;
          height: 35px;
          overflow: visible;
        }

        .handwriting-path {
          fill: #f69220;
          stroke: none;
          clip-path: inset(0 100% 0 0);
          animation: fillReveal 0.5s ease-in-out forwards;
        }
        .handwriting-path:nth-of-type(1) {
          animation-delay: 1s;
        }
        .handwriting-path:nth-of-type(2) {
          animation-delay: 1.25s;
        }
        .handwriting-path:nth-of-type(3) {
          animation-delay: 1.5s;
        }
        .handwriting-path:nth-of-type(4) {
          animation-delay: 1.75s;
        }
        .handwriting-path:nth-of-type(5) {
          animation-delay: 2s;
        }
        .handwriting-path:nth-of-type(6) {
          animation-delay: 2.25s;
        }
        .handwriting-path:nth-of-type(7) {
          animation-delay: 2.5s;
        }
        .handwriting-path:nth-of-type(8) {
          animation-delay: 2.75s;
        }
        .handwriting-path:nth-of-type(9) {
          animation-delay: 3s;
        }

        @keyframes fillReveal {
          to {
            clip-path: inset(0 0 0 0);
          }
        }

        @keyframes logoAnimation {
          0% {
            opacity: 0.25;
            transform: scale(0.25);
          }
          25% {
            opacity: 0.5;
            transform: scale(0.5);
          }
          50% {
            opacity: 0.75;
            transform: scale(0.75);
          }
          75% {
            opacity: 0.875;
            transform: scale(1);
          }
          100% {
            opacity: 1;
            transform: scale(1.25);
          }
        }

        @keyframes handwriting {
          to {
            stroke-dashoffset: 0;
          }
        }
      `}</style>
    </>
  );
};

export default Preloader;
